import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { IoClose } from "react-icons/io5";
import Loader from "../../../custom-components/Loader/Loader";
import { getCompanyResponsesByStatus } from "../../../../utils/api/submissions";

function CompanyResponseWithSuccess({ companyId, timePeriod, searchTerm }) {
  const dispatch = useDispatch();
  const [formResponses, setFormResponses] = useState([]);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const lastRowRef = useRef(null);

  useEffect(() => {
    setFormResponses([]);
    setPage(1);
    setHasMore(true);
  }, [searchTerm, timePeriod]);

  useEffect(() => {
    getCompaniesData();
  }, [page, searchTerm, timePeriod]);

  const openModal = (responses) => {
    setSelectedResponse(responses);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedResponse(null);
  };

  useEffect(() => {
    if (lastRowRef.current) {
      lastRowRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [formResponses]);

  const getCompaniesData = async () => {
    setLoading(true);
    try {
      const result = await getCompanyResponsesByStatus(
        companyId,
        "success",
        page,
        10,
        searchTerm,
        timePeriod
      );
      const newResponses = result?.data?.data;
      if (newResponses.length < 10) {
        setHasMore(false);
      }

      setFormResponses((prevResponses) => [...prevResponses, ...newResponses]);
    } catch (err) {
      console.log(err);
      setFormResponses([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div>
        {!loading ? (
          formResponses?.length > 0 ? (
            <>
              <div
                className={`w-full overflow-x-auto ${
                  formResponses.length > 8 ? "h-[70vh]" : "h-full"
                } overflow-y-auto`}
              >
                <table className="min-w-full text-center border rounded-lg">
                  <thead className="sticky top-0 bg-gray-200">
                    <tr>
                      <th className="py-3 border-b">Form Name</th>
                      {formResponses[0]?.response.map((field, index) => (
                        <th key={index} className="py-3 border-b">
                          {field.fieldName}
                        </th>
                      ))}
                      <th className="py-3 border-b">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formResponses.length > 0 ? (
                      formResponses.map((response, index) => (
                        <tr key={index} className="hover:bg-gray-100">
                          <td className="py-2 border-b">
                            {response.company.form.name}
                          </td>

                          {formResponses[0].response.map((field, idx) => {
                            const matchedField = response.response.find(
                              (f) => f.fieldName === field.fieldName
                            );
                            return (
                              <td key={idx} className="py-2 border-b">
                                {matchedField ? matchedField.fieldValue : ""}
                              </td>
                            );
                          })}
                          <td className="py-2 border-b">
                            <button
                              className="px-4 py-2 font-semibold text-white bg-blue-600 rounded-md hover:bg-blue-700"
                              onClick={() => openModal(response)}
                            >
                              Show Details
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <p className="text-center">No Responses found</p>
                    )}
                    <tr ref={lastRowRef}>
                      <td
                        colSpan={formResponses[0]?.response.length + 2}
                        className="py-2 text-center bg-gray-100"
                      >
                        {hasMore && !loading && (
                          <div className="flex justify-center mt-4">
                            <button
                              onClick={() => setPage((prev) => prev + 1)}
                              className="w-full py-2 text-white bg-purple-700 hover:bg-purple-800 rounded-md"
                            >
                              Load More
                            </button>
                          </div>
                        )}{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {isModalOpen && selectedResponse && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="w-1/3 p-6 bg-white overflow-y-auto h-[80%] rounded-lg shadow-lg relative">
                    <span
                      onClick={closeModal}
                      className="absolute top-2 right-2 text-white cursor-pointer text-sm px-2 py-[2px] bg-black border-l border-b border-gray-600 rounded-es-lg hover:text-gray-300 hover:bg-gray-700 transition-all"
                    >
                      <IoClose size={18} />
                    </span>

                    <h2 className="mb-4 text-xl font-bold">
                      Responses for {selectedResponse.employeeId.name}
                    </h2>

                    <div className="space-y-4 max-h-[70vh] overflow-y-auto">
                      {selectedResponse.response.map((field, fieldIndex) => (
                        <div key={fieldIndex} className="flex flex-col">
                          <label className="font-semibold">
                            {field.fieldName}
                          </label>
                          <input
                            className="px-2 py-1 border rounded-md"
                            type="text"
                            value={field.fieldValue}
                            readOnly
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <p>No responses found</p>
          )
        ) : (
          <div className="my-28">
            <Loader size={"w-24 h-24"} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CompanyResponseWithSuccess;
